import service from './service';

export const generalInfo = async () => {
  const response = await service.getPublicStackTwo('/general/application-info');

  if (response.status === 200) {
    const data = response.data;
    return data;
  }
};
